import { formatDate } from "../../../utils/date";
import { formatNumberWithCommas } from "../../../utils/numbers";
import { getErrorCodeSummary } from "../../../utils/errorCodes";

type Reading = {
  deviceTime: string;
  totalVolume: number;
  errorCode?: number;
  battery?: number;
};

type GenerateProps = {
  meterSerialNo: string;
  readings: Reading[];
  showLiters: boolean;
};

function formatVolume(value: number | null | undefined, showLiters: boolean): string {
  if (value === null || value === undefined) return "--";
  if (showLiters) return formatNumberWithCommas(Math.round(value));
  const truncated = Math.trunc(value / 10) / 100;
  return formatNumberWithCommas(truncated);
}

export default function generateSharedReadingsCsv({ meterSerialNo, readings, showLiters }: GenerateProps) {
  const unitLabel = showLiters ? "(l)" : "(units)";

  const headers = [
    "Date & Time",
    `Volume ${unitLabel}`,
    "Alarms",
    "Battery",
  ];

  const rows = readings.map((row) => {
    const alarmSummary = getErrorCodeSummary(row.errorCode || 0);
    return [
      formatDate(row.deviceTime),
      formatVolume(row.totalVolume, showLiters),
      alarmSummary === "No Errors" ? "None" : alarmSummary,
      row.battery !== undefined && row.battery !== null ? `${row.battery}%` : "--",
    ].map((cell) => `"${String(cell).replace(/"/g, '""')}"`);
  });

  const csvContent = [headers.map((h) => `"${h}"`).join(","), ...rows.map((r) => r.join(","))].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `readings-report-${meterSerialNo}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
